import { api } from "./authService";

const learningDocService = {
    /**
     * Get current learner's learning documentation (URL + files)
     */
    getMyLearningDocumentation: async () => {
        try {
            const response = await api.get("/learners/me/learning-documentation");
            return response.data;
        } catch (error) {
            console.error("Error fetching learning documentation:", error);
            throw error;
        }
    },

    /**
     * Update learning documentation URLs
     */
    updateLearningDocUrl: async (url1, alias1, url2, alias2, url3, alias3) => {
        try {
            const response = await api.put("/learners/me/learning-documentation", {
                learningDocumentationUrl1: url1,
                learningDocumentationAlias1: alias1,
                learningDocumentationUrl2: url2,
                learningDocumentationAlias2: alias2,
                learningDocumentationUrl3: url3,
                learningDocumentationAlias3: alias3,
            });
            return response.data;
        } catch (error) {
            console.error("Error updating learning documentation URLs:", error);
            throw error;
        }
    },

    /**
     * Upload a learning documentation file
     */
    uploadFile: async (file) => {
        try {
            const formData = new FormData();
            formData.append("file", file);

            const response = await api.post(
                "/learners/me/learning-documentation/files",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error uploading learning documentation file:", error);
            throw error;
        }
    },

    /**
     * Delete a learning documentation file
     */
    deleteFile: async (fileId) => {
        try {
            const response = await api.delete(
                `/learners/me/learning-documentation/files/${fileId}`
            );
            return response.data;
        } catch (error) {
            console.error("Error deleting learning documentation file:", error);
            throw error;
        }
    },

    /**
     * Download a learning documentation file (authenticated)
     */
    downloadFile: async (fileId, fileName) => {
        try {
            const response = await api.get(
                `/learners/me/learning-documentation/files/${fileId}`,
                {
                    responseType: "blob",
                }
            );

            // Create a blob URL and trigger download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading learning documentation file:", error);
            throw error;
        }
    },

    /**
     * Get learning documentation for a specific learner (admin access)
     */
    getAdminLearningDocumentation: async (userId) => {
        try {
            const response = await api.get(
                `/admin/learners/${userId}/learning-documentation`
            );
            return response.data;
        } catch (error) {
            console.error(
                `Error fetching learning documentation for user ${userId}:`,
                error
            );
            throw error;
        }
    },

    /**
     * Download a file as admin
     */
    downloadAdminFile: async (fileId, fileName) => {
        try {
            const response = await api.get(
                `/admin/learning-documentation/files/${fileId}/download`,
                { responseType: "blob" }
            );

            // Create blob link to download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            // Use provided filename or default
            link.setAttribute("download", fileName || "download");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(`Error downloading file ${fileId}:`, error);
            throw error;
        }
    },

    /**
     * Get admin download URL for a file
     */
    getAdminFileDownloadUrl: (fileId) => {
        const baseURL = api.defaults.baseURL || "";
        return `${baseURL}/admin/learning-documentation/files/${fileId}/download`;
    },
};

export default learningDocService;
